export const SBSearch = ({ color = "#28287B" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.9269 17.0401L20.4 20.4001M11.4 7.2001C13.3882 7.2001 15 8.81187 15 10.8001M19.28 11.4401C19.28 15.77 15.7699 19.2801 11.44 19.2801C7.11009 19.2801 3.6 15.77 3.6 11.4401C3.6 7.11018 7.11009 3.6001 11.44 3.6001C15.7699 3.6001 19.28 7.11018 19.28 11.4401Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};
